import { render, staticRenderFns } from "./ShiftsPerBrief.vue?vue&type=template&id=47eb6766"
import script from "./ShiftsPerBrief.vue?vue&type=script&lang=js"
export * from "./ShiftsPerBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports